var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { config } from 'lib-shared-backend-config';
import { Suspense, useMemo } from 'react';
import { analytics } from 'app/utils/segment';
import { useNotifications } from 'hooks/useNotifications';
import { authManager } from 'utils/auth/authManager';
import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading/knowledgeLoading';
import { RemoteKnowledgeDeliveryRoutes } from './components/remotes';
export const KnowledgeDeliveryRoutes = () => {
    const notify = useNotifications();
    const onHandlers = useMemo(() => {
        const handlers = {
            'article:viewed': (payload) => analytics.knowledgeArticleViewed(payload),
            'articles:searched-by-terms': (payload) => analytics.knowledgeArticlesSearchByTermSubmitted(payload),
            'collection:viewed': (payload) => analytics.knowledgeCollectionViewed(payload),
            'internalKb:dashboard-viewed': (payload) => analytics.knowledgeInternalKbDashboardViewed(payload),
            'internalKb:search-result-clicked': (payload) => analytics.knowledgeInternalKbSearchResultClicked(payload),
        };
        return handlers;
    }, []);
    return (_jsx(ErrorBoundary, Object.assign({ fallback: _jsx(KnowledgeErrorPlaceholder, {}) }, { children: _jsx(Suspense, Object.assign({ fallback: _jsx(KnowledgeLoading, {}) }, { children: _jsx(RemoteKnowledgeDeliveryRoutes, { getLock: () => __awaiter(void 0, void 0, void 0, function* () { return yield authManager.getAuth(); }), on: onHandlers, notify: notify, environment: config.environment }) })) })));
};
